<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <simple-wizard
        :prevButtonText="$lang.keys.back"
        :nextButtonText="$lang.keys.next"
        :finishButtonText="$lang.keys.save"
      >
        <template slot="header">
          <h3 class="title">{{$lang.titles.lora_settings}}</h3>
          <!-- <h5 class="category"></h5>-->
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">{{$lang.titles.basic}}</template>
          <first-step ref="step1" @on-validated="onStepValidated" :settings="generalSettings"></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">{{$lang.titles.details}}</template>
          <second-step ref="step2" @on-validated="onStepValidated" :settings="detailsSettings"></second-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step3')">
          <template slot="label">{{$lang.titles.data}}</template>
          <third-step
            ref="step3"
            @on-validated="onStepValidated"
            :settings="payloadSettings"
            :SF="dataRate"
          ></third-step>
        </wizard-tab>
      </simple-wizard>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import hierarchyMenu from "@/components/HierarchyMenu";
import graphToolBar from "@/components/GraphToolBar";
import axios from "axios";
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import { handleRedirect } from "@/routes/routes";

import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep.vue";
import ThirdStep from "./ThirdStep.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  components: {
    "hierarchy-menu": hierarchyMenu,
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab
  },

  props: {
    loraData: {
      type: Object,
      default: {}
    },
    systemData: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      wizardModel: {},

      generalSettings: {
        id: "",
        application_key: "",
        network_key: ""
      },
      detailsSettings: {
        force_DRSF: false,
        boot_msg: false,
        loraMsgOnWifi: false
      },
      payloadSettings: {
        supported: [],
        map: []
      },
      dataRate: ""
    };
  },

  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },

  watch: {
    loraData() {
      if (this.loraData.settings) {
        this.generalSettings = {
          id: this.loraData.settings.ID,
          application_key: this.loraData.settings.APPLICATION_KEY,
          network_key: this.loraData.settings.NETWORK_KEY
        };

        this.detailsSettings.echo = this.loraData.settings.ECHO;
        this.detailsSettings.alive = this.loraData.settings.ALIVE;
        this.detailsSettings.DRSF = this.loraData.settings.DRSF.toString();
        this.detailsSettings.force_DRSF = this.loraData.settings.DRSF_FORCE;
        this.detailsSettings.boot_msg = this.loraData.settings.boot_msg;
        this.detailsSettings.loraMsgOnWifi = this.loraData.settings.LORA_MSG_WHEN_WIFI_CONNECT;

        this.detailsSettings.scaler_p = this.systemData.scaler_P;
        this.detailsSettings.scaler_t = this.systemData.scaler_T;

        const channelsArr = this.loraData.settings.channels
          .toString(2)
          .padStart(8, "0")
          .split("")
          .reverse();
        for (let index = 0; index < 8; index++) {
          if (channelsArr[index] == 1) {
            this.detailsSettings.channels.push(index.toString());
          }
        }

        this.payloadSettings.supported = this.loraData.settings.MAP;

        let SNDConcat = [];
        if (this.loraData.settings.SND) {
          SNDConcat = SNDConcat.concat(
            this.loraData.settings.SND.toString(2)
              .padStart(32, "0")
              .split("")
              .reverse()
          );
        }

        if (this.loraData.settings.SND2) {
          SNDConcat = SNDConcat.concat(
            this.loraData.settings.SND2.toString(2)
              .padStart(32, "0")
              .split("")
              .reverse()
          );
        }

        if (this.loraData.settings.SND3) {
          SNDConcat = SNDConcat.concat(
            this.loraData.settings.SND3.toString(2)
              .padStart(32, "0")
              .split("")
              .reverse()
          );
        }

        const switchArrayLen = SNDConcat.length;
        for (let index = 0; index < switchArrayLen; index++) {
          if (SNDConcat[index] == 1) {
            this.payloadSettings.map.push(this.loraData.settings.MAP[index]);
          }
        }
      }
    }
  },

  methods: {
    validateStep(ref) {
      const validation = this.$refs[ref].validate();
      if (ref == "step2") {
        validation.then(response => {
          this.dataRate = this.wizardModel.DRSF;
        });
      }
      return validation;
    },

    onStepValidated(validated, model, finish) {
      this.wizardModel = { ...this.wizardModel, ...model };
      if (finish) {
        this.wizardComplete();
      }
    },

    bit_set(num, bit) {
      return num | (1 << bit);
    },

    wizardComplete() {
      let SND_new = 0;
      let SND2_new = 0;
      let SND3_new = 0;

      this.wizardModel.MAP.forEach(element => {
        const index = this.payloadSettings.supported.findIndex(
          e => e == element
        );
        if (index !== -1) {
          if (index < 32) {
            SND_new = this.bit_set(SND_new, index);
          } else if (index < 64) {
            SND2_new = this.bit_set(SND2_new, index);
          } /* else  if (index < 96){
            SND3_new = this.bit_set(SND3_new, index);
          } */
        }
      });

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/devices/config",
        data: {
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          user_token: getUserToken(),
          system: {
            scaler_p: this.wizardModel.scaler_p,
            scaler_t: this.wizardModel.scaler_t
          },
          lora: {
            ID: this.wizardModel.id,
            APPLICATION_KEY: this.wizardModel.application_key,
            NETWORK_KEY: this.wizardModel.network_key,
            ECHO: this.wizardModel.echo,
            ALIVE: this.wizardModel.alive,
            DRSF: this.wizardModel.DRSF,
            DRSF_FORCE: this.wizardModel.force_DRSF,
            boot_msg: this.wizardModel.boot_msg,
            LORA_MSG_WHEN_WIFI_CONNECT: this.wizardModel.loraMsgOnWifi,
            channels: this.wizardModel.channels,
            SND: SND_new,
            SND2: SND2_new
          }
        },
        withCredentials: true
      })
        .then(response => {
          Swal.fire({
            title: this.$lang.messages.success,
            text: this.$lang.messages.lora_settings_successfully_set,
            type: "success",
            confirmButtonClass: "md-button md-success",
            confirmButtonText: this.$lang.keys.close,
            buttonsStyling: false,
            timer: 2000
            // onClose: () => {
            //   this.$router.push({
            //     path: handleRedirect()
            //   });
            // }
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code == 604) {
              Swal.fire({
                title: this.$lang.messages.error,
                text: this.$lang.messages.device_not_responding_or_offline,
                type: "error",
                confirmButtonClass: "md-button md-warning",
                confirmButtonText: this.$lang.keys.close,
                buttonsStyling: false
              });
            } else {
              Swal.fire({
                title: this.$lang.messages.error,
                text: this.$lang.messages.api_communication_error,
                type: "error",
                confirmButtonClass: "md-button md-warning",
                confirmButtonText: this.$lang.keys.close,
                buttonsStyling: false
              });
            }
          }
        });
    }

    // loadData() {
    //   axios({
    //     method: "POST",
    //     url: this.$ENDPOINTS.API_R + "/devices/config",
    //     data: {
    //       token: getSelectedDeviceToken(this.selectedDevice.mac)
    //     },
    //     withCredentials: true
    //   })
    //     .then(response => {
    //       if (response.data.data.LORA.plugged) {
    //         this.generalSettings.id = response.data.data.LORA.settings.ID;
    //         this.generalSettings.application_key =
    //           response.data.data.LORA.settings.APPLICATION_KEY;
    //         this.generalSettings.network_key =
    //           response.data.data.LORA.settings.NETWORK_KEY;

    //         this.detailsSettings.echo = response.data.data.LORA.settings.ECHO;
    //         this.detailsSettings.alive = response.data.data.LORA.settings.ALIVE;
    //         this.detailsSettings.DRSF = response.data.data.LORA.settings.DRSF.toString();
    //         this.detailsSettings.force_DRSF =
    //           response.data.data.LORA.settings.DRSF_FORCE;
    //         this.detailsSettings.boot_msg =
    //           response.data.data.LORA.settings.boot_msg;
    //         this.detailsSettings.loraMsgOnWifi =
    //           response.data.data.LORA.settings.LORA_MSG_WHEN_WIFI_CONNECT;

    //         this.detailsSettings.scaler_p = response.data.data.system.scaler_P;
    //         this.detailsSettings.scaler_t = response.data.data.system.scaler_T;

    //         const channelsArr = response.data.data.LORA.settings.channels
    //           .toString(2)
    //           .padStart(8, "0")
    //           .split("")
    //           .reverse();
    //         for (let index = 0; index < 8; index++) {
    //           if (channelsArr[index] == 1) {
    //             this.detailsSettings.channels.push(index.toString());
    //           }
    //         }

    //         this.payloadSettings.supported =
    //           response.data.data.LORA.settings.MAP;

    //         let SNDConcat = [];
    //         if (response.data.data.LORA.settings.SND) {
    //           SNDConcat = SNDConcat.concat(
    //             response.data.data.LORA.settings.SND.toString(2)
    //               .padStart(32, "0")
    //               .split("")
    //               .reverse()
    //           );
    //         }

    //         if (response.data.data.LORA.settings.SND2) {
    //           SNDConcat = SNDConcat.concat(
    //             response.data.data.LORA.settings.SND2.toString(2)
    //               .padStart(32, "0")
    //               .split("")
    //               .reverse()
    //           );
    //         }

    //         if (response.data.data.LORA.settings.SND3) {
    //           SNDConcat = SNDConcat.concat(
    //             response.data.data.LORA.settings.SND3.toString(2)
    //               .padStart(32, "0")
    //               .split("")
    //               .reverse()
    //           );
    //         }

    //         const switchArrayLen = SNDConcat.length;
    //         for (let index = 0; index < switchArrayLen; index++) {
    //           if (SNDConcat[index] == 1) {
    //             this.payloadSettings.map.push(
    //               response.data.data.LORA.settings.MAP[index]
    //             );
    //           }
    //         }
    //       }
    //     })
    //     .catch(error => {
    //       if (error.response) {
    //         if (error.response.data.code == 604) {
    //           this.$refs.snackbar.notify(
    //             this.$lang.messages.device_not_responding_or_offline
    //           );
    //         } else {
    //           this.$refs.snackbar.notify(
    //             this.$lang.messages.api_communication_error
    //           );
    //         }
    //       }
    //     });
    // }
  }
};
</script>

<style scoped>
</style>